import { Mui, MuiIcons } from "@osu/react-ui";
import ListHeading from "./ListHeading";
import { forwardRef, Fragment } from "react";

const customStyles = (theme) => {
  const darkMode = theme?.palette?.mode === "dark";
  if(darkMode) {
    const dark = `var(--elevation1)`
    const light = theme.palette.secondary.main
    return {
      backgroundColor: light,
      color: dark,
      [`&.${Mui.chipClasses.root}.${Mui.chipClasses.clickable}:hover`]: {
        backgroundColor: dark,
        color: light,
      }
    }
  }
}

const Email = forwardRef((props, ref) => <Fragment>
  <Mui.Typography variant="srOnly">email </Mui.Typography>
  <MuiIcons.Email {...props} ref={ref}/>
</Fragment>)

function Primary({ title, statusDate, statusName, dueDate, name, email, headingLevel, id }) {
  let mailto = email && "mailto:" + email;
  if (mailto && (title || name))
    mailto += `?subject=${title || name}`;

  return (
    <Fragment>
      <ListHeading 
        title={title} name={name}
        statusName={statusName}
        statusDate={statusDate}
        dueDate={dueDate}
        email={email}
        headingLevel={headingLevel}
        className="margin-bottom-1"
        id={id}
      >
      </ListHeading>
      {mailto && (
        <Mui.Chip
          variant="outlined"
          icon={<Email />}
          component="a"
          color="secondary"
          size="small"
          className="margin-bottom-1 padding-x-1 align-self-start font-weight-bold"
          href={mailto}
          label={email}
          clickable
          sx={customStyles}
        />
      )}
    </Fragment>
  );
}

export default Primary;
